<template>
  <ul>
    <PaymentItem :item="teamRegistrationPayment" isRegistrationPaymentItem />
    <PaymentItem
      v-for="item in addOnsInfoSummaryList"
      :key="item.fileMetadataId"
      :item="item"
    />
  </ul>
</template>

<script>
import PaymentItem from "./PaymentItem";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { mapGetters } from "vuex";
import { i18n } from "../../../plugins/i18n";
import { RegistrationTypes } from "../enums/RegistrationTypes";

export default {
  name: "PaymentConfirmationList",
  components: { PaymentItem },
  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerRegistrationSummary",
      "playerRegistration",
      "playerProfileForm"
    ]),

    addOnsInfoSummaryList() {
      return this.playerRegistrationSummary?.addOnsInfoSummaryList;
    },

    teamRegistrationPayment() {
      const registrationType =
        this.playerRegistrationSummary.registrationType ===
        RegistrationTypes.TEAM
          ? `${i18n.tc("team_registration.team_registration")}`
          : `${i18n.tc("team_registration.event_registration")}`;
      return {
        name: `${registrationType} - ${this.playerRegistrationSummary?.registrationOptionName}`,
        priceInCents: this.playerRegistrationSummary?.upcharge,
        description:
          this.playerRegistration?.value === "new_player"
            ? `${this.findFormFieldByName(
                "Player First Name"
              )} ${this.findFormFieldByName("Player Last Name")}`
            : this.playerRegistration.name
      };
    }
  },
  methods: {
    findFormFieldByName(name) {
      const foundItem = this.playerProfileForm?.find(
        item => item.name === name
      );

      return foundItem ? foundItem?.value : "";
    }
  }
};
</script>

<style scoped></style>
